import appCONST from 'constants/app.constants';

export default function HotelsAPIFactory($http) {
    'ngInject';

        return {
            getPreviousSearches: function(amount) {
                const params = {
                    topResults: amount,
                };
                return $http.apiGET('/UserSearchParameters/UserSearch/AllHotels', {
                    params,
                    noSpinner: true,
                });
            },

            getFrequentLocations: function() {
                return $http.apiGET('/Authorize/GetFrequentLocationsForHotels', {noSpinner: true});
            },

            getMapMarkers: function(params) {
                return $http.apiGET('/hotels/GetMarkers', {params});
            },

            fetchHotelDetails: function(params) {
                const request = _.pick(params, ['hotelId', 'searchId']);
                return $http.apiGET('/hotels/GetDetails', {params: request})
                    .then(({data}) => data);
            },

            searchHotels: function(params) {
                const url = `${appCONST.apiUrl}/hotels/Search`;
                 return $http.get(url, {params, timeout: appCONST.productSearchTimeout})
                     .then(({data}) => data);
            },

            filterHotels: function(params) {
                const url = `${appCONST.apiUrl}/hotels/Filter`;
                return $http.get(url, {params, timeout: appCONST.productSearchTimeout})
                    .then(({data}) => data);
            },

            searchFilteredHotels: (params) => {
                const url = `${appCONST.apiUrl}/hotels/SearchAndFilter`;
                return $http.get(url, {params, timeout: appCONST.productSearchTimeout})
                    .then(({data}) => data);
            },

            getAvailableRooms: (params) => {
                const url = `${appCONST.apiUrl}/hotels/rooms`;
                return $http.get(url, {params, noSpinner: true})
                    .then(({data}) => data);
            },
        };
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/hotelsAPI.js